/**
 * Validates a JSON Structured Data string. That would be a string that can safely
 * translate to a key value object, where the keys and values are JSON valid.
 **
 * @param {string} jsonString - The JSON Structured Data string to validate.
 * @throws {Error} Throws an error if the JSON string cannot be parsed on a key value object
 */
export function validateJSONStructuredData(jsonStr: string): void {
  try {
    const parsedJSON = JSON.parse(jsonStr);
    if (parsedJSON && typeof parsedJSON === 'object' && !Array.isArray(parsedJSON)) {
      return;
    }
    throw new Error('jsonStr is not a string that represents structured data in the form of a key value object');
  } catch (e) {
    throw new Error(`JSON could not be parsed: ${e.message}`);
  }
}
